import Layout from '@/components/LayoutPage.vue'
export default [
  {
    path: '',
    name: '',
    redirect: '/home',
    component: Layout,
    // meta: {
    //   isAuth: true
    // },
    children: [
      {
        path: '/home',
        alias: '/home/',
        name: 'Home',
        component: () => import('../components/homePage.vue'),
        meta: {
          keywords:
            'Coupon Codes, Coupons, Deals, Discounts, Free Shipping, Free Trial, Free Gift, Cashback, Gift Card, Free Shipping, Free Trial, Free Gift, Cashback, Gift Card',
          description:
            'Coupon Codes, Coupons, Deals, Discounts, Free Shipping, Free Trial, Free Gift, Cashback, Gift Card, Free Shipping, Free Trial, Free Gift, Cashback, Gift Card',
          'twitter:title':
            'Coupon Codes, Coupons, Deals, Discounts, Free Shipping, Free Trial, Free Gift, Cashback, Gift Card, Free Shipping, Free Trial, Free Gift, Cashback, Gift Card',
          'twitter:description':
            'Coupon Codes, Coupons, Deals, Discounts, Free Shipping, Free Trial, Free Gift, Cashback, Gift Card, Free Shipping, Free Trial, Free Gift, Cashback, Gift Card',
          'og:title':
            'Coupon Codes, Coupons, Deals, Discounts, Free Shipping, Free Trial, Free Gift, Cashback, Gift Card, Free Shipping, Free Trial, Free Gift, Cashback, Gift Card',
          'og:description':
            'Coupon Codes, Coupons, Deals, Discounts, Free Shipping, Free Trial, Free Gift, Cashback, Gift Card, Free Shipping, Free Trial, Free Gift, Cashback, Gift Card'
        }
      },
      {
        path: '/coupon/:url/code',
        name: 'couponDetail',
        component: () => import('../components/couponDetail.vue'),
        meta: {
          description:
            '## Coupons, ## Coupon Code,## Promo Code, ## Discount Code',
          keywords:
            '## Coupons, ## Coupon Code,## Promo Code, ## Discount Code',
          'twitter:title': "## Today's Coupon Code",
          'twitter:description':
            '## Coupons, ## Coupon Code, ## Promo Code, ## Discount Code',
          'og:title': "## Today's Coupon Code",
          'og:description':
            '## Coupons, ## Coupon Code, ## Promo Code, ## Discount Code',
          robots: 'index, follow'
        }
      },
      {
        path: '/about-contact',
        name: 'About',
        component: () => import('../components/AboutContact.vue')
      },
      {
        path: '/terms-conditions',
        name: 'TermsConditions',
        component: () => import('../components/termsConditions.vue')
      },
      {
        path: '/cookie-policy',
        name: 'cookiePolicy',
        component: () => import('../components/cookiePolicy.vue')
      }
    ]
  }
]
